<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M11.9979 21.332C11.9979 21.332 4.23389 16.667 4.23389 10.444C4.23389 6.14802 7.71589 2.66602 12.0119 2.66602C16.3079 2.66602 19.7899 6.14802 19.7899 10.444C19.7899 16.667 11.9979 21.332 11.9979 21.332Z"
        :stroke="color" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path
        d="M12.0119 13.556C13.73 13.556 15.1229 12.1632 15.1229 10.445C15.1229 8.72686 13.73 7.33402 12.0119 7.33402C10.2937 7.33402 8.90089 8.72686 8.90089 10.445C8.90089 12.1632 10.2937 13.556 12.0119 13.556Z"
        :stroke="color" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<script>
export default {
  name: 'LocationIcon',
  props: {
    color: {
      type: String,
      default: '#6DB8FF',
    },
  },
};
</script>
